/**
 * @author Lucas Fridez <lfridez@artionet.com>
 * @client Inelectro
 * @project webapp-scan
 * @file src\app\framework\user\User.ts
 * @copyright 2018 Artionet Web Agency
 */

/**
 * @description Class User which correspond to the table tb_user in Back-End
 * @author Lucas Fridez <fridez.lucas@gmail.com>
 * @export
 * @class User
 */
export class User {
    private _id: string;
    private _name: string;
    private _surname: string;
    private _username: string;
    private _profile: number;
    private _title: string;

    /**
     * Creates an instance of User.
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} json json object received from API
     * @memberof User
     */
    constructor(json) {
        this._id = json.id;
        this._name = json.name;
        this._surname = json.surname;
        this._username = json.username;
        this._profile = json.profile;
        this._title = json.title;
    }

    /**
     * @description Return the id
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @memberof User
     */
    public get id(): string {
        return this._id;
    }

    /**
     * @description Return the name
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @memberof User
     */
    public get name(): string {
        return this._name;
    }

    /**
     * @description Return the surname
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @memberof User
     */
    public get surname(): string {
        return this._surname;
    }

    /**
     * @description Return the username
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @memberof User
     */
    public get username(): string {
        return this._username;
    }

    /**
     * @description Return the profile
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @memberof User
     */
    public get profile(): number {
        return this._profile;
    }

    /**
     * @description Return the title
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @memberof User
     */
    public get title(): string {
        return this._title;
    }
}



// WEBPACK FOOTER //
// ./src/app/framework/user/User.ts